/* eslint-disable */
export default {
  inviteMeetingContent:
    '{accountName}から{brandName}会議に招待されています。\n\nPC、Mac、iOS、またはAndroidから参加：{joinUri}{passwordTpl}\n\n またはiPhoneで1回タップ：\n\t    {mobileDialingNumberTpl}\n\n    または電話：\n\t     ダイヤル:\n\t    {phoneDialingNumberTpl}\n\t     会議ID：{meetingId}\n\t     利用可能な国際電話番号：{teleconference} ',
  conferenceLocationField: '音声会議、ダイヤルイン番号：{dialInNumber}',
  scheduleError:
    '問題が発生しました。お手数をおかけしますが、もう一度やり直してください。',
  noMeetingPermission:
    '申し訳ございませんが、お客様は{brandName} Meetingsに参加する権限をお持ちではありません。続行するには、会社の管理者にお問い合わせください。',
  noConferencePermission:
    '申し訳ございませんが、お客様は{brandName}電話会議に参加する権限をお持ちではありません。続行するには、会社の管理者にお問い合わせください。',
  conferenceTitle: '{displayName}の音声会議',
  internationalNumber: '国際ダイヤルイン番号：',
  inviteText_att:
    '{brandName}会議に参加してください。\n\nダイヤルイン番号：{formattedDialInNumber} \n{additionalNumbersSection} \n参加者アクセス：{participantCode} \n\n国際ダイヤルイン番号が必要な場合は、{dialInNumbersLink}にアクセスしてください。 \n\nこの電話会議は{brandName} Conferencingによって提供されます。',
  inviteText_bt:
    '{brandName}会議に参加してください。\n\nダイヤルイン番号：{formattedDialInNumber} \n{additionalNumbersSection} \n参加者アクセス：{participantCode} \n\n追加のダイヤルイン番号{dialInNumbersLink} ',
  inviteText_rc:
    '{brandName}会議に参加してください。\n\nダイヤルイン番号：{formattedDialInNumber} \n{additionalNumbersSection} \n参加者アクセス：{participantCode} \n\n国際ダイヤルイン番号が必要な場合は、{dialInNumbersLink}にアクセスしてください。 \n\nこの電話会議は{brandName} Conferencingによって提供されます。',
  inviteText_telus:
    '{brandName}会議に参加してください。\n\nダイヤルイン番号：{formattedDialInNumber} \n{additionalNumbersSection} \n参加者アクセス：{participantCode} \n\n追加のダイヤルイン番号{dialInNumbersLink} ',
  conferenceCall: '{brandName} 電話会議',
  videoCall: '{brandName}ビデオ通話',
  addConferencingDetails: '会議開催の詳細を追加中',
  updateConferencingDetails: '会議開催の詳細を更新中',
  // @ts-expect-error TS(1117): An object literal cannot have multiple properties ... Remove this comment to see the full error message
  scheduleError:
    '問題が発生しました。お手数をおかけしますが、もう一度やり直してください。',
  deleteBtn: '削除',
  settingsBtn: '設定',
  saveAsDefaultAndNotShowAgain: '既定として保存し次から表示しない',
  saveAsDefault: '既定として保存',
  done: '完了',
  update: '更新',
  conferenceSettingsTitle: '{brand}会議の設定',
  videoSettingsTitle: '{brand} Meetingsの設定',
  password: 'パスワード',
  failedToRetrieveMeeting:
    'ネットワーク接続が切断されています。会議を削除し、後でもう一度やり直してください。',
  meetingSettingsTitle: '{brand} Meetings - 設定',
  recurringMeeting: '定期的な会議',
  meetingOptions: '会議オプション',
  schedule: 'スケジュール',
  // @ts-expect-error TS(1117): An object literal cannot have multiple properties ... Remove this comment to see the full error message
  settingsBtn: '設定',
} as const;

// @key: @#@"inviteMeetingContent"@#@ @source: @#@"{accountName} is inviting you to a {brandName} meeting.\n\nJoin from PC, Mac, iOS or Android: {joinUri}{passwordTpl}\n\n Or iPhone one-tap:\n\t    {mobileDialingNumberTpl}\n\n    Or Telephone:\n\t     Dial:\n\t    {phoneDialingNumberTpl}\n\t     Meeting ID: {meetingId}\n\t     International numbers available: {teleconference} "@#@
// @key: @#@"conferenceLocationField"@#@ @source: @#@"Conference Meeting, Dial-in Number: {dialInNumber}"@#@
// @key: @#@"scheduleError"@#@ @source: @#@"Sorry, something went wrong, please try again."@#@
// @key: @#@"noMeetingPermission"@#@ @source: @#@"Sorry, you don't have {brandName} Meetings permissions. Contact your company administrator to continue."@#@
// @key: @#@"noConferencePermission"@#@ @source: @#@"Sorry, you don't have {brandName} Conference permissions. Contact your company administrator to continue."@#@
// @key: @#@"conferenceTitle"@#@ @source: @#@"{displayName}'s Conference Meeting"@#@
// @key: @#@"internationalNumber"@#@ @source: @#@"International Dial-in Numbers:"@#@
// @key: @#@"inviteText_att"@#@ @source: @#@"Please join the {brandName} conference.\n\nDial-In Number: {formattedDialInNumber} \n{additionalNumbersSection} \nParticipant Access: {participantCode} \n\nNeed an international dial-in phone number? Please visit {dialInNumbersLink} \n\nThis conference call is brought to you by {brandName} Conferencing."@#@
// @key: @#@"inviteText_bt"@#@ @source: @#@"Please join the {brandName} conference.\n\nDial-In Number: {formattedDialInNumber} \n{additionalNumbersSection} \nParticipant Access: {participantCode} \n\nAdditional dial-in numbers {dialInNumbersLink} "@#@
// @key: @#@"inviteText_rc"@#@ @source: @#@"Please join the {brandName} conference.\n\nDial-In Number: {formattedDialInNumber} \n{additionalNumbersSection} \nParticipant Access: {participantCode} \n\nNeed an international dial-in phone number? Please visit {dialInNumbersLink} \n\nThis conference call is brought to you by {brandName} Conferencing."@#@
// @key: @#@"inviteText_telus"@#@ @source: @#@"Please join the {brandName} conference.\n\nDial-In Number: {formattedDialInNumber} \n{additionalNumbersSection} \nParticipant Access: {participantCode} \n\nAdditional dial-in numbers {dialInNumbersLink} "@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"{brandName} Conference Call"@#@
// @key: @#@"videoCall"@#@ @source: @#@"{brandName} Video Call"@#@
// @key: @#@"addConferencingDetails"@#@ @source: @#@"Adding conferencing details"@#@
// @key: @#@"updateConferencingDetails"@#@ @source: @#@"Updating conferencing details"@#@
// @key: @#@"deleteBtn"@#@ @source: @#@"Delete"@#@
// @key: @#@"settingsBtn"@#@ @source: @#@"Settings"@#@
// @key: @#@"saveAsDefaultAndNotShowAgain"@#@ @source: @#@"Save as default and do not show again"@#@
// @key: @#@"saveAsDefault"@#@ @source: @#@"Save as default"@#@
// @key: @#@"done"@#@ @source: @#@"Done"@#@
// @key: @#@"update"@#@ @source: @#@"Update"@#@
// @key: @#@"conferenceSettingsTitle"@#@ @source: @#@"{brand} Conference Settings"@#@
// @key: @#@"videoSettingsTitle"@#@ @source: @#@"{brand} Meetings Settings"@#@
// @key: @#@"password"@#@ @source: @#@"Password"@#@
// @key: @#@"failedToRetrieveMeeting"@#@ @source: @#@"The network connection is lost. Delete this meeting and try again later."@#@
// @key: @#@"meetingSettingsTitle"@#@ @source: @#@"{brand} Meetings - Settings"@#@
// @key: @#@"recurringMeeting"@#@ @source: @#@"Recurring Meeting"@#@
// @key: @#@"meetingOptions"@#@ @source: @#@"Meeting Options"@#@
// @key: @#@"schedule"@#@ @source: @#@"Schedule"@#@
